export default __webpack_public_path__ + "static/media/icon_no_image.a0d015b8.jpg";